export default __webpack_public_path__ + "static/media/Creative1.795cf82f.png";